import React from "react"
import Loginform from "../../Components/Auth/Lform"
export const Loginpage = () => {
  return (
    <div>
      <Loginform />
    </div>
  )
}
